import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {AccessService} from "../../utils/AccessService";
import {LocalStorage} from "../../utils/LocalStorage";
import {fetchPortalSubscriptionGating} from "../../utils/usePortalSubscriptionGating";
import { withTranslation } from 'react-i18next';
import {useUiVersion} from "../../context/UserModulesContext";
import {AgencyTabsV2} from "./AgencyTabsV2";

class AgencyTabsComponent extends Component {

    constructor(props) {
        super(props);

        this.handleGetUserModules = this.handleGetUserModules.bind(this);

        this.state = {
            modules: null,
            // El uso del portal no existe para una agencia cuyo plan no lo incluye: sin este gate
            // la pestaña llevaría al 404 uniforme del endpoint. Mismo criterio (y mismo cache) que
            // el sidebar de la 2.1 y que el tab «Portal del cliente» de la ficha.
            canAssignToPortal: false
        };
    }

    handleGetUserModules(data) {
        this.setState({
            ...this.state,
            modules: data.modules
        });
    }

    getUserModules() {
        AccessService.GetUserModules(this.getUserId(), this.handleGetUserModules, null)
    }

    getUserId() {
        return LocalStorage.fetchUserId()
    }

    componentDidMount() {
        this._mounted = true;
        this.getUserModules();
        fetchPortalSubscriptionGating().then((canAssignToPortal) => {
            if (this._mounted) this.setState({canAssignToPortal});
        });
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    renderModuleMarketingTabsAsList() {
        const { t } = this.props;
        if (!this.state.modules.includes(AccessService.MODULE_MARKETING))
            return []

        return [
            <li key="clients">
                <Link className="tab-button" to="/agency/clients">
                    {t('agency_tabs.clients')}
                </Link>
            </li>,
            <li key="clients">
                <Link className="tab-button" to="/agency-team">
                    {t('agency_tabs.team')}
                </Link>
            </li>,
            <li key="ad-accounts">
                <Link className="tab-button" to="/agency/ad-accounts">
                    {t('agency_tabs.accounts')}
                </Link>
            </li>,
            <li key="alerts-configuration">
                <Link className="tab-button" to="/agency/alerts-configuration">
                    {t('agency_tabs.alerts')}
                </Link>
            </li>
        ]
    }

    renderTabs(listOfTabs) {
        return (<ul className={'tabs ' + this.props.activeTab}>{listOfTabs}</ul>);
    }

    render() {
        const { t } = this.props;
        if (!this.state.modules)
            return "";

        const tabs = this.renderModuleMarketingTabsAsList()
        tabs.push(<li key="agency/profile"><Link className="tab-button" to="/agency/profile">{t('agency_tabs.profile')}</Link></li>);
        tabs.push(<li key="agency/conections"><Link className="tab-button" to="/agency/conections">{t('agency_tabs.connections')}</Link></li>);
        tabs.push(<li key="agency/personalization"><Link className="tab-button" to="/agency/personalization">{t('agency_tabs.metric_personalization')}</Link></li>);
        // Va ANTES de «Suscripción» a propósito: `-last` de `_layout.scss` matchea por
        // `li:last-child`, así que apendear al final le robaría el estilo de activo a la pestaña de
        // suscripción. Insertando acá, ninguna de las posicionales existentes se corre.
        if (this.state.canAssignToPortal) {
            tabs.push(<li key="agency/portal-usage"><Link className="tab-button" to="/agency/portal-usage">{t('agency_tabs.portal_usage')}</Link></li>);
        }
        tabs.push(<li key="agency/subscription"><Link className="tab-button" to="/agency/subscription">{t('agency_tabs.subscription')}</Link></li>);

        return (
            <div className="filters">
                {this.renderTabs(tabs)}
            </div>
        )
    }
}

const AgencyTabsClassic = withTranslation()(AgencyTabsComponent);

/**
 * En la 2.1 (tanda «Agencia 2.1», D2) las solapas son `AgencyTabsV2`: salen de la lista del
 * desplegable, se marcan por ruta y no llevan «Clientes» ni «Portal». En el clásico, las de siempre,
 * sin tocar: las montan 13 pantallas con su `activeTab` posicional.
 *
 * La misma decisión que el marco (`LayoutSidebar`): las solapas nunca discrepan del riel.
 */
export function AgencyTabs(props) {
    const {isV2} = useUiVersion();
    if (isV2) return <AgencyTabsV2/>;
    return <AgencyTabsClassic {...props}/>;
}